
import axios from "axios";
import toast from "react-hot-toast";

export const CREATE_ROLE_REQUEST = "CREATE_ROLE_REQUEST";
export const CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS";
export const CREATE_ROLE_FAILURE = "CREATE_ROLE_FAILURE";

export const CREATE_PERMISSION_REQUEST = "CREATE_PERMISSION_REQUEST";
export const CREATE_PERMISSION_SUCCESS = "CREATE_PERMISSION_SUCCESS";
export const CREATE_PERMISSION_FAILURE = "CREATE_PERMISSION_FAILURE";

export const FETCH_ROLES_REQUEST = "FETCH_ROLES_REQUEST";
export const FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS";
export const FETCH_ROLES_FAILURE = "FETCH_ROLES_FAILURE";

export const FETCH_PERMISSIONS_REQUEST = "FETCH_PERMISSIONS_REQUEST";
export const FETCH_PERMISSIONS_SUCCESS = "FETCH_PERMISSIONS_SUCCESS";
export const FETCH_PERMISSIONS_FAILURE = "FETCH_PERMISSIONS_FAILURE";

export const ASSIGN_ROLE_PERMISSION_REQUEST = "ASSIGN_ROLE_PERMISSION_REQUEST";
export const ASSIGN_ROLE_PERMISSION_SUCCESS = "ASSIGN_ROLE_PERMISSION_SUCCESS";
export const ASSIGN_ROLE_PERMISSION_FAILURE = "ASSIGN_ROLE_PERMISSION_FAILURE";

export const FETCH_ROLE_PERMISSIONS_REQUEST = "FETCH_ROLE_PERMISSIONS_REQUEST";
export const FETCH_ROLE_PERMISSIONS_SUCCESS = "FETCH_ROLE_PERMISSIONS_SUCCESS";
export const FETCH_ROLE_PERMISSIONS_FAILURE = "FETCH_ROLE_PERMISSIONS_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// ✅ Create Role with Toast
export const createRole = (data) => async (dispatch) => {
  dispatch({ type: CREATE_ROLE_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const res = await axios.post(`${BASE_URL}/v1/api/create-role`, data, {
      headers: { authorization: token },
    });
    dispatch({ type: CREATE_ROLE_SUCCESS });
    toast.success(res?.data?.meta?.message || "Role created successfully");
  } catch (error) {
    const message = error?.response?.data?.meta?.message || "Failed to create role";
    dispatch({ type: CREATE_ROLE_FAILURE, payload: message });
    toast.error(message);
  }
};

// ✅ Create Permission with Toast
export const createPermission = (data) => async (dispatch) => {
  dispatch({ type: CREATE_PERMISSION_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const res = await axios.post(`${BASE_URL}/v1/api/create-permission`, data, {
      headers: { authorization: token },
    });
    dispatch({ type: CREATE_PERMISSION_SUCCESS });
    toast.success(res?.data?.meta?.message || "Permission created successfully");
  } catch (error) {
    const message = error?.response?.data?.meta?.message || "Failed to create permission";
    dispatch({ type: CREATE_PERMISSION_FAILURE, payload: message });
    toast.error(message);
  }
};

// ✅ Fetch Roles with Error Toast
export const fetchRoles = () => async (dispatch) => {
  dispatch({ type: FETCH_ROLES_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const res = await axios.get(`${BASE_URL}/v1/api/get-role-list`, {
      headers: { authorization: token },
    });
    dispatch({ type: FETCH_ROLES_SUCCESS, payload: res.data.data });
  } catch (error) {
    const message = error?.response?.data?.meta?.message || "Failed to fetch roles";
    dispatch({ type: FETCH_ROLES_FAILURE, payload: message });
    toast.error(message);
  }
};

// ✅ Fetch Permissions with Error Toast
export const fetchPermissions = () => async (dispatch) => {
  dispatch({ type: FETCH_PERMISSIONS_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const res = await axios.get(`${BASE_URL}/v1/api/get-permission-list`, {
      headers: { authorization: token },
    });
    dispatch({ type: FETCH_PERMISSIONS_SUCCESS, payload: res.data.data });
  } catch (error) {
    const message = error?.response?.data?.meta?.message || "Failed to fetch permissions";
    dispatch({ type: FETCH_PERMISSIONS_FAILURE, payload: message });
    toast.error(message);
  }
};

// ✅ Assign Role Permissions with Toast
export const assignRolePermissions = (data) => async (dispatch) => {
  dispatch({ type: ASSIGN_ROLE_PERMISSION_REQUEST });
  const token = localStorage.getItem("token");
  try {
    const res = await axios.post(`${BASE_URL}/v1/api/assignRolePermissions`, data, {
      headers: { authorization: token },
    });
    dispatch({ type: ASSIGN_ROLE_PERMISSION_SUCCESS });
    toast.success(res?.data?.meta?.message || "Permissions assigned successfully");
  } catch (error) {
    const message = error?.response?.data?.meta?.message || "Failed to assign permissions to role";
    dispatch({ type: ASSIGN_ROLE_PERMISSION_FAILURE, payload: message });
    toast.error(message);
  }
};

// ✅ Fetch Role Permissions with Error Toast
export const fetchRolePermissions = (roleId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ROLE_PERMISSIONS_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${BASE_URL}/v1/api/getRolePermissions`, {
        headers: { authorization: token },
      });
      dispatch({
        type: FETCH_ROLE_PERMISSIONS_SUCCESS,
        payload: res.data.data,
      });
    } catch (error) {
      const message = error?.response?.data?.meta?.message || "Failed to fetch role permissions";
      dispatch({
        type: FETCH_ROLE_PERMISSIONS_FAILURE,
        payload: message,
      });
      toast.error(message);
    }
  };
};
